import React from "react"
import styled from "styled-components"
import { H1Style } from "./Styles"

const StyledH1 = styled.h1`
  ${H1Style};
`;

const H1 = ({children}) => {
  return (
    <StyledH1>
      {children}
    </StyledH1>
  );
};

export default H1;
